module.exports = __WEBPACK_EXTERNAL_MODULE__8976__;